/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decrease_TimecodeInputs */



/**
* | output |
* | --- |
* | "Decrease timecode by 1.000/1.001" |
*
* @param {Decrease_TimecodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const decrease_timecode = /** @type {((inputs?: Decrease_TimecodeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decrease_TimecodeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Diminuer le timecode de 1,000/1,001")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verringere den Timecode um 1,000/1,001")
	if (locale === "it") return /** @type {LocalizedString} */ ("Diminuisci il timecode di 1.000/1.001")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Уменьшите временной код на 1.000/1.001")
	if (locale === "es") return /** @type {LocalizedString} */ ("Disminuir el código de tiempo en 1.000/1.001")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将时间码减少 1.000/1.001")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムコードを1.000/1.001ずつ減らす")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टाइमकोड को 1.000/1.001 से घटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Diminua o código de tempo em 1,000/1,001.")
	return /** @type {LocalizedString} */ ("Decrease timecode by 1.000/1.001")
});